// src/components/EmployeeDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid,
  FormGroup, FormControlLabel, Checkbox, Typography
} from '@mui/material';

function EmployeeDialog({ open, onClose, onSave, initialEmployee, roles }) {
  // Định nghĩa trạng thái ban đầu cho một nhân viên trống
  const initialEmployeeState = { 
    fullName: '', 
    username: '', 
    password: '', 
    phone: '', 
    department: '', 
    roles: [] 
  };

  const [employee, setEmployee] = useState(initialEmployeeState);
  const isEditMode = !!initialEmployee;

  useEffect(() => {
    // Chỉ cập nhật state khi dialog được mở
    if (open) {
      if (initialEmployee) {
        // Chế độ chỉnh sửa: điền thông tin từ nhân viên hiện tại
        setEmployee({
          ...initialEmployee,
          password: '', // Không bao giờ hiển thị mật khẩu hiện tại
        });
      } else {
        // Chế độ tạo mới: reset state về trạng thái trống ban đầu
        setEmployee(initialEmployeeState);
      }
    }
  }, [open, initialEmployee]); // Chạy lại effect khi `open` hoặc `initialEmployee` thay đổi

  const handleChange = (e) => setEmployee(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleRoleChange = (event) => {
    const { name, checked } = event.target;
    setEmployee(prev => {
      const currentRoles = prev.roles || [];
      const newRoles = checked
        ? [...currentRoles, name]
        : currentRoles.filter(roleId => roleId !== name);
      return { ...prev, roles: newRoles };
    });
  };

  const handleSave = () => {
    if (!employee.fullName || !employee.username) {
      alert('Vui lòng nhập đầy đủ Họ tên và Username (Email).');
      return;
    }
    if (!isEditMode && (!employee.password || employee.password.length < 6)) {
        alert('Vui lòng nhập mật khẩu cho nhân viên mới. Mật khẩu phải có ít nhất 6 ký tự.');
        return;
    }
    onSave(employee);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditMode ? `Chỉnh sửa Nhân viên: ${employee.fullName}` : 'Thêm Nhân viên mới'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField name="fullName" label="Họ và Tên (*)" fullWidth value={employee.fullName} onChange={handleChange} autoFocus />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="username" label="Username (Email) (*)" fullWidth value={employee.username} onChange={handleChange} type="email" disabled={isEditMode} />
          </Grid>
          {!isEditMode && (
            <Grid item xs={12}>
              <TextField
                required
                name="password"
                label="Mật khẩu (*)"
                fullWidth
                value={employee.password}
                onChange={handleChange}
                type="password"
                helperText="Mật khẩu phải có ít nhất 6 ký tự."
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <TextField name="phone" label="Số điện thoại" fullWidth value={employee.phone} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="department" label="Phòng ban" fullWidth value={employee.department} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
             <Typography variant="subtitle1" sx={{mt: 1}}>Phân quyền Vai trò:</Typography>
             <FormGroup row>
               {(roles || []).map(role => (
                 <FormControlLabel
                   key={role.id}
                   control={
                     <Checkbox
                       checked={(employee.roles || []).includes(role.id)}
                       onChange={handleRoleChange}
                       name={role.id}
                     />
                   }
                   label={role.name}
                 />
               ))}
             </FormGroup>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button onClick={handleSave} variant="contained">Lưu</Button>
      </DialogActions>
    </Dialog>
  );
}
export default EmployeeDialog;